// extracted by mini-css-extract-plugin
export default {"widgetsContainer":"widgetsContainer---siF8u","rotate":"rotate---RyCVU"};